import React, { useState, useEffect } from "react";
import FormField from "../../../components/ui/FormField";
import { Button } from "../../../components/Button";

const ShTwoForm = () => {
    const [entries, setEntries] = useState(() => {
        const saved = localStorage.getItem("sh2_register_data");
        return saved ? JSON.parse(saved) : [{ id: Date.now() }];
    });

    useEffect(() => {
        localStorage.setItem("sh2_register_data", JSON.stringify(entries));
    }, [entries]);

    const updateField = (id, field, value) => {
        setEntries(prev => prev.map(entry => 
            entry.id === id ? { ...entry, [field]: value } : entry
        ));
    };

    const addEntry = () => {
        setEntries([...entries, { id: Date.now() }]);
    };

    const deleteEntry = (id) => {
        if (entries.length > 1) {
            setEntries(entries.filter(e => e.id !== id));
        }
    };

    const saveData = () => {
    console.log("SH-2 REGISTER DATA:");
    console.log(JSON.stringify(entries, null, 2));
};

    return (
        <div className="max-w-7xl mx-auto p-4 md:p-8 bg-gray-50 min-h-screen font-sans text-gray-800">
            <div className="bg-white border-b-4 p-8 mb-8 text-center shadow-sm rounded-t-lg">
                <h1 className="text-2xl font-black uppercase">Form No. SH - 2</h1>
                <h2 className="text-lg font-bold mt-1">Register of Renewed and Duplicate Share Certificates</h2>
                <p className="text-[10px] italic text-slate-500 mt-2">
                    [Pursuant to sub-section (3) of section 46 of the Companies Act, 2013 and rule 6(3)(a) the Companies (Share Capital and Debentures) Rules 2014]
                </p>
            </div>

            <div className="space-y-10">
                {entries.map((entry, index) => (
                    <div key={entry.id} className="bg-white border border-gray-200 rounded-xl shadow-md overflow-hidden transition-all hover:shadow-lg">
                        <div className="bg-primary text-white px-6 py-3 flex justify-between items-center">
                            <span className="font-bold text-xs uppercase tracking-widest">Entry Serial No: {index + 1}</span>
                            {entries.length > 1 && (
                                <button onClick={() => deleteEntry(entry.id)} className="text-[10px] bg-red-600 px-2 py-1 rounded hover:bg-red-700 font-bold uppercase">
                                    Remove Record
                                </button>
                            )}
                        </div>

                        <div className="p-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {/* Columns 1-15 mapped directly from image */}
                            <FormField label="(1) S. No." value={entry.sno} onChange={(v) => updateField(entry.id, 'sno', v)} />
                            <FormField label="(2) Folio No." value={entry.folioNo} onChange={(v) => updateField(entry.id, 'folioNo', v)} />
                            
                            <div className="md:col-span-2 lg:col-span-1">
                                <FormField label="(3) Name of the person(s) to whom Renewed / Duplicate share certificate is issued" value={entry.recipientName} onChange={(v) => updateField(entry.id, 'recipientName', v)} />
                            </div>

                            <FormField label="(4) Date of approval of issue of Renewed/ Duplicate share certificate" type="date" value={entry.approvalDate} onChange={(v) => updateField(entry.id, 'approvalDate', v)} />
                            <FormField label="(5) Class of shares" value={entry.shareClass} onChange={(v) => updateField(entry.id, 'shareClass', v)} />
                            <FormField label="(6) Date of issue of original share certificate" type="date" value={entry.origIssueDate} onChange={(v) => updateField(entry.id, 'origIssueDate', v)} />
                            
                            <FormField label="(7) Original share certificate number" value={entry.origCertNo} onChange={(v) => updateField(entry.id, 'origCertNo', v)} />
                            <FormField label="(8) Total number of shares in the Original Share Certificate" type="number" value={entry.origTotalShares} onChange={(v) => updateField(entry.id, 'origTotalShares', v)} />

                            {/* Column 9: Nested Distinctive Numbers */}
                            <div className="p-4 border-2 border-slate-100 rounded-lg bg-slate-50/50">
                                <label className="block text-[10px] font-black text-slate-400 uppercase mb-3">(9) Distinctive No. of shares</label>
                                <div className="grid grid-cols-2 gap-4">
                                    <FormField label="From" value={entry.distFrom} onChange={(v) => updateField(entry.id, 'distFrom', v)} />
                                    <FormField label="To" value={entry.distTo} onChange={(v) => updateField(entry.id, 'distTo', v)} />
                                </div>
                            </div>

                            <FormField label="(10) Date of issue of Renewed/ Duplicate Share Certificate" type="date" value={entry.renewedIssueDate} onChange={(v) => updateField(entry.id, 'renewedIssueDate', v)} />
                            <FormField label="(11) Reasons for issue of Renewed/ Duplicate Share Certificate" type="description" value={entry.reasons} onChange={(v) => updateField(entry.id, 'reasons', v)} />
                            <FormField label="(12) Number of the Renewed share certificate, if applicable" value={entry.renewedCertNo} onChange={(v) => updateField(entry.id, 'renewedCertNo', v)} />
                            
                            <FormField label="(13) Total Number of Shares in the Renewed/ Duplicate Share Certificate" type="number" value={entry.renewedTotalShares} onChange={(v) => updateField(entry.id, 'renewedTotalShares', v)} />
                            <FormField label="(14) Reference to entry in Register of Members" value={entry.refMembers} onChange={(v) => updateField(entry.id, 'refMembers', v)} />
                            <FormField label="(15) Remarks" type="description" value={entry.remarks} onChange={(v) => updateField(entry.id, 'remarks', v)} />
                        </div>
                    </div>
                ))}
            </div>

            <Button 
            label="Add New SH-2"
                onClick={addEntry}
                className="mt-2 mr-2"
           />
            <Button
            label="Save"
    onClick={saveData}
    className="mt-2 ml-2"
/>

        </div>
    );
};

export default ShTwoForm;